import { z } from 'zod';
import { BRAND_CONSTRAINTS } from './constraints.js';
export const createBrandSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${BRAND_CONSTRAINTS.name.label} is required`)
        .max(BRAND_CONSTRAINTS.name.maxLength, `${BRAND_CONSTRAINTS.name.label} must be ${BRAND_CONSTRAINTS.name.maxLength} characters or fewer`),
});
//# sourceMappingURL=create-form.js.map